import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import { EMAIL_FONT_FAMILIES, THEME_OPTIONS, THEME_IMAGE, DEFAULT_OPTIONS, MEDIA_FIELDS } from './EmailFontData';
import { Autocomplete } from '@material-ui/lab';
import {Nav, NavItem, NavLink, TabContent, TabPane, Button,Modal,FormGroup, ButtonToolbar, ModalBody} from 'reactstrap';
import {Form, Field} from 'react-final-form';
import { getEmailTemplateData, getEventEmailTemplateData } from '@/services/program/getEmailTemplateData';
import { Row, Col, Input } from 'reactstrap';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import { getThemeByName , getTheme} from '@/services/getProgramEmailTemplates';
import Slider from "@/shared/components/form/Slider"
import renderDropZoneField from '@/shared/components/form/DropZone';
import renderSelectOptionsField from '@/shared/components/form/SelectOptions';
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor'
import axios from 'axios';
import {unpatchMedia, mapFormDataUploads} from '@/shared/helpers'
import { ColorPicker } from 'material-ui-color';
import { inArray } from '@/shared/helpers';
import './EditEmailTemplate.css';

import {useDispatch, flashError, flashSuccess} from "@/shared/components/flash"


const EditEmailTemplate = ({  program, editMode, toggleEditMode, eventTypeId, event }) => {
    
    const dispatch = useDispatch();
    let [templateTheme, setTemplate] = useState(program.template)
    const [loading, setLoading] = useState(false)
    const [currentTheme, setCurrentTheme] = useState(null);
    const [emailSubject, setEmailSubject] = useState('')

    useEffect(() => {
        if(event?.id){
            getEventEmailTemplateData(program.organization_id, program.id, event.id).then((data) => {
                setTemplate(data.data)     
                setEmailSubject(data.data?.subject);
                setCurrentTheme(data.data?.name); 
                setSliderValue(parseInt(templateTheme.button_corner))
                setSelectedColor(templateTheme.button_color)
                setSelectedThemeColor(templateTheme.theme_color)
                setSelectedBGColor(templateTheme.button_bg_color)
                setFontFamily(templateTheme.font_family)   
            }).catch((err)=>{
                console.log("err",err);
                //setLoadingTemplate(false)
            });
        }else if (program && eventTypeId) {

            getEmailTemplateData(program.organization_id, program.id, eventTypeId).then((data) => {
                setTemplate(data.data)     
                setEmailSubject(data.data?.subject);
                setCurrentTheme(data.data?.name);   
                setCurrentTheme(data.data?.name); 
                setSliderValue(parseInt(templateTheme.button_corner))
                setSelectedColor(templateTheme.button_color)
                setSelectedThemeColor(templateTheme.theme_color)
                setSelectedBGColor(templateTheme.button_bg_color)
                setFontFamily(templateTheme.font_family)        
            }).catch((err)=>{
                console.log("err",err);
                //setLoadingTemplate(false)
            });
            
        }else{
            //
            setCurrentTheme(program?.template?.name);
        }
        
        getSetTheme(program)
    }, [editMode]);
    
    // Theme Color
    const [selectedThemeColor, setSelectedThemeColor] = useState(null);

    // Color
    const [selectedColor, setSelectedColor] = useState(null);
   
    // BG Color
    const [selectedBGColor, setSelectedBGColor] = useState(null);
     
    // Font Type
    const [fontFamily, setFontFamily] = useState(null);
    const [ stylePath, setStylePath ] = useState("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");
    const fontFamilyHandler = (e, data) => {
        setStylePath("https://fonts.googleapis.com/css?family="+data+":100,300,400,500,700,900");
        setFontFamily(data);
    };

    // Tabs Panel
    const [currentActiveTab, setCurrentActiveTab] = useState('1');
    const togglePan = (tab) => {
        if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    }

    // Slider
    const SliderConfig = [
        {
            value: 0,
            label: "Square",
        },
        {
            value: 20,
            label: "Rounded",
        },
    ];
    const [sliderValue, setSliderValue] = useState(0);
    const updateSliderRange = (e, data) => {
        if (typeof data === 'number' && sliderValue !== data ) {
            templateTheme.button_corner = data;
            setTemplate(templateTheme);
            setSliderValue(data);
        }
    };

    const isShowDeleteImage = (fieldName) => {
        if( currentTheme != 'Default' ) {
          if( templateTheme?.inherited?.fields && typeof templateTheme.inherited.fields === 'object')
          {
            if(inArray(fieldName, templateTheme.inherited.fields)) {
              return false
            }
          }
          return true;
        }
    }
  
    const deleteImage = (name) => {
        //console.log(template.inherited)
        return;
        
    }

    const onSelectTheme = (selectedOption) => {
        getThemeByName(program.organization_id, program.id, selectedOption.value)
        .then( theme => {
            setTemplate(theme ? theme : {})
        })
        setCurrentTheme(selectedOption.value);
    };

    const validate = (values) => {
        // console.log(values)
        let errors = {}
        if( !values.name && !currentTheme )
        {
          errors.name = 'Select a theme'
        }
        if( !values.small_logo && !templateTheme?.small_logo )
        {
          errors.small_logo = 'Event logo is required'
        }
        if( !fontFamily )
        {
          errors.font_family = 'font_family is required'
        }
        // setError(errors)
        return errors
    }

    const onSubmitForm = async (values) => {
        values.button_corner = sliderValue;
        values.theme_color = selectedThemeColor;
        values.button_color = selectedColor;
        values.button_bg_color = selectedBGColor;
        values.font_family = fontFamily;
        values.name = currentTheme;
        if(event)
            values.event_id = event?.id;
        setLoading(true)
        let saveUrl = `/organization/${program.organization_id}/program/${program.id}/eventType/${eventTypeId}/emailtemplate`;
        values = unpatchMedia(values, MEDIA_FIELDS)
        let formData = mapFormDataUploads( values )
        axios.post(saveUrl, formData, {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
        })
        .then( (res) => {
            if(res.status === 200)  {
                flashSuccess(dispatch, 'Event Email Template updated successfully');
                setLoading(false)
            }
        })
        .catch( error => {
            flashError(dispatch, error.response.data.errors)
            setLoading(false)
        }) 
    }
    

    let formError = false;

    const getSetTheme = (program) => {
        getTheme(program.organization_id, program.id)
          .then( theme => {
            setTemplate(theme ? theme : {})
          })
      }

    
    useEffect(() => {
      var head = document.head;
      var link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = stylePath;
      head.appendChild(link);
      return () => { head.removeChild(link); }
    }, [stylePath]);
    
    
   
    const setButtonBgColor = (color) => {
        setSelectedBGColor('#'+color.hex)
    }

    //const [actionButtonText, setActionButtonText] = useState(null);

    const handleSelectChange = (value, name) => {
        setTemplate(
            (prev) => ({
                ...prev,
                [name]: value,
            })
        );
    };

  return (
    <Modal
        className={`modal-event-email modal-lg`}
        isOpen={editMode}
        toggle={toggleEditMode}
    >
        <Form
            onSubmit={onSubmitForm}
            validate={validate}
            initialValues={templateTheme}
        >
        {({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="form" onSubmit={handleSubmit}>
                <ModalBody className=''>
                    <Row className='w-100'>
                        <Col md="6" lg="6" xl="6">
                            <h3 style={{"fontWeight": 500}}>Email Template Options</h3>
                            <h5 style={{"fontWeight": 500, color:'#999'}}>{program.name}</h5>
                        </Col>
                        <Col md="6" lg="6" xl="6" className='text-right'>
                            <ButtonToolbar className="modal__footer flex justify-content-right w100">
                                <Button outline color="primary" className="mr-3" onClick={toggleEditMode} >Close</Button>{' '}
                                {formError = Object.keys(validate(values)).length > 0}
                                <Button type="submit" disabled={submitting || formError || currentTheme === 'Default'} className="btn btn-primary" color="#ffffff">Save</Button>
                                {(currentTheme && formError && !submitting && !loading) && <div className="error">Required fields missing</div>}
                            </ButtonToolbar>
                        </Col>
                        <hr/>
                    </Row>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                    currentActiveTab === '1'
                                })}
                                onClick={() => { togglePan('1'); }}
                            >
                                Theme
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                    currentActiveTab === '2'
                                })}
                                onClick={() => { togglePan('2'); }}
                            >
                                General
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                    currentActiveTab === '3'
                                })}
                                onClick={() => { togglePan('3'); }}
                            >
                                Image
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                    currentActiveTab === '4'
                                })}
                                onClick={() => { togglePan('4'); }}
                            >
                                Buttons
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                    currentActiveTab === '5'
                                })}
                                onClick={() => { togglePan('5'); }}
                            >
                                Font Style
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={currentActiveTab}>
                        <TabPane tabId="1">
                            <Row>
                                <Col sm="3">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Current Theme<span className='error'>*</span></span>
                                        <div className="form__form-group-field flex-column">
                                            <Field
                                                name="name"
                                                component={renderSelectOptionsField}
                                                options={THEME_OPTIONS}
                                                fieldValue={currentTheme}
                                                fieldOnChange={onSelectTheme}
                                                value={currentTheme}
                                                placeholder={' -- select -- '}
                                            />
                                        </div>
                                        <div>&nbsp;</div>
                                        {/*<Button onClick={() => onClickResetTheme() } disabled={loading || !currentTheme || !template?.id} className="btn btn-primary" color="#ffffff">
                                            Reset theme settings to default
                                        </Button>*/}
                                    </div>

                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Theme Color</span>
                                        <div className="form__form-group-field flex-column">
                                            <ColorPicker
                                                name="theme_color"
                                                floatingLabelText={selectedThemeColor}
                                                value={selectedThemeColor}
                                                onChange={color =>{if (color) setSelectedThemeColor('#'+color.hex)}}
                                            />
                                        </div>
                                        <div>&nbsp;</div>
                                        <div>&nbsp;</div>
                                    </div>
                                </Col>
                                <Col sm="9">
                                    <div className="button-result">
                                        <br/>
                                        <div
                                            style={{fontFamily: "'" + fontFamily + "', sans-serif", textAlign: 'left'}}
                                        >
                                            <img src={THEME_IMAGE[currentTheme]} className="" alt="" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="2">   
                            <Row className='w-100'>
                                <Col xs="12" md="12" lg="12">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Subject</span>
                                        <div className="form__form-group-field flex-column">
                                            <Field name="email_subject" >
                                                {({ input, meta }) => (
                                                <FormGroup>
                                                    <Input
                                                        id="email_subject"
                                                        name="email_subject"
                                                        placeholder="Email Subject"
                                                        type="text"
                                                        value={emailSubject} 
                                                        onChange={(e) => setEmailSubject(e.target.value)}
                                                    />
                                                    {meta.touched && meta.error && <span className="text-danger">
                                                    {meta.error}
                                                    </span>}
                                                </FormGroup>
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='w-100'>
                                <Col xs="12" md="12" lg="12">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Welcome Message</span>
                                        <div className="form__form-group-field flex-column">
                                            <Field
                                                name="welcome_message"
                                                component={WYSIWYGEditor}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='w-100'>
                                <Col xs="12" md="12" lg="12">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Award Prefix Message</span>
                                        <div className="form__form-group-field flex-column">
                                            <div className="form__form-group-field flex-column">
                                                <Field
                                                    name="award_prefix_message"
                                                    component={WYSIWYGEditor}
                                                    
                                                    value={templateTheme?.award_prefix_message}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='w-100'>
                                <Col xs="12" md="12" lg="12">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Password Set Up</span>
                                        <div className="form__form-group-field flex-column">
                                            <div className="form__form-group-field flex-column">
                                                <Field
                                                    name="password_setup_message"
                                                    component={WYSIWYGEditor}
                                                    value={templateTheme?.password_setup_message}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='w-100'>
                                <Col xs="12" md="12" lg="12">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Paricipant Homepage Message</span>
                                        <div className="form__form-group-field flex-column">
                                            <Field
                                                name="participant_homepage_message"
                                                component={WYSIWYGEditor}
                                            />
                                    
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='w-100'>
                                <Col xs="4" md="4" lg="4">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Show Password Set Up Link<span className='error'>*</span></span>
                                        <div className="form__form-group-field flex-column">
                                            <Field
                                                name="show_password_link"
                                                component={renderSelectOptionsField}
                                                options={DEFAULT_OPTIONS}
                                                fieldValue={templateTheme?.show_password_link}
                                                fieldOnChange={(e) => handleSelectChange(e.value, "show_password_link")}
                                                placeholder={' -- select -- '}
                                            />
                                        </div>
                                        <div>&nbsp;</div>
                                        
                                    </div>
                                </Col>
                                <Col xs="4" md="4" lg="4">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Show App Download Link<span className='error'>*</span></span>
                                        <div className="form__form-group-field flex-column">
                                            <Field
                                                name="show_app_download_link"
                                                component={renderSelectOptionsField}
                                                options={DEFAULT_OPTIONS}
                                                fieldValue={templateTheme?.show_app_download_link}
                                                fieldOnChange={(e) => handleSelectChange(e.value, "show_app_download_link")}
                                                placeholder={' -- select -- '}
                                            />
                                        </div>
                                        <div>&nbsp;</div>
                                        
                                    </div>
                                </Col>
                                <Col xs="4" md="4" lg="4">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Show Unsubscribe Link<span className='error'>*</span></span>
                                        <div className="form__form-group-field flex-column">
                                            <Field
                                                name="show_unsubscribe_link"
                                                component={renderSelectOptionsField}
                                                options={DEFAULT_OPTIONS}
                                                fieldValue={templateTheme?.show_unsubscribe_link}
                                                fieldOnChange={(e) => handleSelectChange(e.value, "show_unsubscribe_link")}
                                                placeholder={' -- select -- '}
                                            />
                                        </div>
                                        <div>&nbsp;</div>
                                    </div>
                                </Col>
                            </Row>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </TabPane>
                        <TabPane tabId="3">
                            <Row>
                                <Col xs="12" md="3" lg="3">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Big Logo</span><span className='error'>*</span>
                                        <div className="form__form-group-field  flex-column">
                                            {currentTheme !== 'Default' && <Field
                                                name="big_logo"
                                                component={renderDropZoneField}
                                                multiple={false}
                                                customHeight
                                                uploadTitle={{type: 'short', displayAlways: true}}
                                            />}
                                            <div className='image-wrap'>
                                                <RenderImage src={templateTheme?.big_logo} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs="12" md="3" lg="3">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Small Logo</span><span className='error'>*</span>
                                        <div className="form__form-group-field flex-column">
                                        {currentTheme !== 'Default' && <Field
                                                name="small_logo"
                                                component={renderDropZoneField}
                                                multiple={false}
                                                customHeight
                                                uploadTitle={{type: 'short', displayAlways: true}}
                                            />}
                                            <div className='image-wrap'>
                                                <RenderImage src={templateTheme?.small_logo} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs="12" md="6" lg="6">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Hero Banner</span><span className='error'>*</span>
                                        <div className="form__form-group-field  flex-column">
                                        {currentTheme !== 'Default' && <Field
                                                name="hero_banner"
                                                component={renderDropZoneField}
                                                multiple={false}
                                                customHeight
                                                uploadTitle={{type: 'short', displayAlways: true}}
                                            />}
                                            <div className='image-wrap'>
                                                <RenderImage src={templateTheme?.hero_banner} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <p className="form__form-group-label thick">Slider Images<span className='error'>*</span></p>
                            <Row>
                                <Col xs="12" md="4" lg="4">
                                    <div className="form__form-group">
                                        <div className="form__form-group-field  flex-column">
                                        {currentTheme !== 'Default' && <Field
                                                name="slider_01"
                                                component={renderDropZoneField}
                                                multiple={false}
                                                customHeight
                                                uploadTitle={{type: 'short', displayAlways: true}}
                                            />}
                                            <div className='image-wrap'>
                                                <RenderImage src={templateTheme?.slider_01} showDelete={isShowDeleteImage('slider_01')}  name='slider_01' dlcb={deleteImage} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs="12" md="4" lg="4">
                                    <div className="form__form-group">
                                        <div className="form__form-group-field  flex-column">
                                        {currentTheme !== 'Default' && <Field
                                                name="slider_02"
                                                component={renderDropZoneField}
                                                multiple={false}
                                                customHeight
                                                uploadTitle={{type: 'short', displayAlways: true}}
                                            />}
                                            <div className='image-wrap'>
                                                <RenderImage src={templateTheme?.slider_02} showDelete={isShowDeleteImage('slider_02')}  name='slider_02' dlcb={deleteImage} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs="12" md="4" lg="4">
                                    <div className="form__form-group">
                                        <div className="form__form-group-field  flex-column">
                                        {currentTheme !== 'Default' && <Field
                                                name="slider_03"
                                                component={renderDropZoneField}
                                                multiple={false}
                                                customHeight
                                                uploadTitle={{type: 'short', displayAlways: true}}
                                            />}
                                            <div className='image-wrap'>
                                                <RenderImage src={templateTheme?.slider_03}  showDelete={isShowDeleteImage('slider_03')} name='slider_03' dlcb={deleteImage} />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </TabPane>
                        <TabPane tabId="4">
                            <Row>
                                <Col sm="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Button Text</span>
                                        <div className="form__form-group-field flex-column">
                                            <Field name="button_text" >
                                                {({ input, meta }) => (
                                                <FormGroup>
                                                
                                                    <Input
                                                        id="button_text"
                                                        name="button_text"
                                                        placeholder="Button Text"
                                                        type="text"
                                                        value={ templateTheme?.button_text} 
                                                        onChange={(e) => handleSelectChange(e.target.value, "button_text")}
                                                    />
                                                    {meta.touched && meta.error && <span className="text-danger">
                                                    {meta.error}
                                                    </span>}
                                                </FormGroup>
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Shape</span>
                                        <div>&nbsp;</div>
                                        <div className="form__form-group-field flex-column shape-slider">
                                        {currentTheme !== 'Default' && <Slider
                                                max={20}
                                                SliderConfig={SliderConfig}
                                                value={sliderValue}
                                                onChange={updateSliderRange}
                                                name='button_corner'
                                            />}
                                        </div>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Color</span>
                                        <div className="form__form-group-field flex-column">
                                            <ColorPicker
                                                name="color"
                                                floatingLabelText = {selectedColor}
                                                value={selectedColor}
                                                onChange={color =>{if (color) setSelectedColor('#'+color.hex)}}
                                            />
                                        </div>
                                    </div>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Background Color</span>
                                        <div className="form__form-group-field flex-column">
                                            <ColorPicker
                                                name="background_color"
                                                floatingLabelText={selectedBGColor}
                                                value={selectedBGColor}
                                                onChange={(color) =>{if (color)  setSelectedBGColor('#'+color.hex) }}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col sm="4">
                                    <div className="button-result">
                                        <span className="form__form-group-label thick">Result</span>
                                        <br/>
                                        <br/>
                                        
                                        <Button
                                            style={{borderRadius: sliderValue, color: selectedColor, backgroundColor: selectedBGColor}}
                                            className="template-button"
                                            onClick={() => {return false;}}>
                                             
                                            { templateTheme?.button_text || 'My Button'}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </TabPane>
                        <TabPane tabId="5">
                            <Row className='w-100'>
                                <Col sm="8">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label thick">Font Type</span><span className='error'>*</span>
                                        <div className="form__form-group-field flex-column">
                                            <Autocomplete
                                                className='custom_autocomplete'
                                                id="font_family"
                                                options={EMAIL_FONT_FAMILIES}
                                                sx={{width: 300}}
                                                onChange={fontFamilyHandler}
                                                value={fontFamily}
                                                renderInput={(params) => <TextField {...params}
                                                name='font_family' label="Choose Font" margin="normal"
                                                />}
                                            />
                                            {!fontFamily && <span className="form__form-group-error">Font family is required</span>}
                                        </div>
                                    </div>
                                </Col>
                                <Col sm="4">
                                    <div className="button-result">
                                        <span className="form__form-group-label thick">Result</span>
                                        <br/>
                                        <br/>
                                        <div
                                            style={{fontFamily: "'" + fontFamily + "', sans-serif", textAlign: 'left'}}
                                            >
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Etiam vulputate, odio sit amet finibus porta, elit nunc lobortis metus,
                                            a gravida metus velit et augue.
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </TabPane>
                    </TabContent>
                </ModalBody>
            </form>
        )}
        </Form>
    </Modal>)
}

const RenderImage = ({src, showDelete = false, name, dlcb }) => {
    if( !src || typeof src === 'undefined' ) return ''
    return (
      <div className='dropzone-img position-relative'>
        <a href={src} target='_blank' title='View the picture'>
          <img style={{maxHeight:200}} src={src} />
        </a>
        {(showDelete && dlcb) && <button className="dropzone__img-delete" style={{opacity:1,color:'black',backgroun:'#fff'}} onClick={() => dlcb(name)} type="button">Remove</button>}
      </div>
    )
}

EditEmailTemplate.propTypes = {
    template: PropTypes.string.isRequired, 
    program: PropTypes.object.isRequired, 
    editMode: PropTypes.bool.isRequired,
    toggleEditMode: PropTypes.func.isRequired, 
    eventTypeId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
    event: PropTypes.object
}

export default EditEmailTemplate